/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InvestmentDetailsSourceOfMoneySplitViewModel } from './InvestmentDetailsSourceOfMoneySplitViewModel';
import {
    InvestmentDetailsSourceOfMoneySplitViewModelFromJSON,
    InvestmentDetailsSourceOfMoneySplitViewModelFromJSONTyped,
    InvestmentDetailsSourceOfMoneySplitViewModelToJSON,
} from './InvestmentDetailsSourceOfMoneySplitViewModel';
import type { PaymentDetailsCashTransferInvestmentViewModel } from './PaymentDetailsCashTransferInvestmentViewModel';
import {
    PaymentDetailsCashTransferInvestmentViewModelFromJSON,
    PaymentDetailsCashTransferInvestmentViewModelFromJSONTyped,
    PaymentDetailsCashTransferInvestmentViewModelToJSON,
} from './PaymentDetailsCashTransferInvestmentViewModel';
import type { PaymentDetailsSourceOfMoneyViewModel } from './PaymentDetailsSourceOfMoneyViewModel';
import {
    PaymentDetailsSourceOfMoneyViewModelFromJSON,
    PaymentDetailsSourceOfMoneyViewModelFromJSONTyped,
    PaymentDetailsSourceOfMoneyViewModelToJSON,
} from './PaymentDetailsSourceOfMoneyViewModel';
import type { SimplifiedLookupResponseViewModel } from './SimplifiedLookupResponseViewModel';
import {
    SimplifiedLookupResponseViewModelFromJSON,
    SimplifiedLookupResponseViewModelFromJSONTyped,
    SimplifiedLookupResponseViewModelToJSON,
} from './SimplifiedLookupResponseViewModel';

/**
 * 
 * @export
 * @interface PaymentDetailsCashTransferViewModel
 */
export interface PaymentDetailsCashTransferViewModel {
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsCashTransferViewModel
     */
    paymentCategoryId: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsCashTransferViewModel
     */
    paymentMethodId?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsCashTransferViewModel
     */
    totalAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsCashTransferViewModel
     */
    partyId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentDetailsCashTransferViewModel
     */
    isInvestor?: boolean;
    /**
     * 
     * @type {Array<SimplifiedLookupResponseViewModel>}
     * @memberof PaymentDetailsCashTransferViewModel
     */
    investmentNames?: Array<SimplifiedLookupResponseViewModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentDetailsCashTransferViewModel
     */
    hasSingleInvestmentName?: boolean;
    /**
     * 
     * @type {Array<PaymentDetailsSourceOfMoneyViewModel>}
     * @memberof PaymentDetailsCashTransferViewModel
     */
    sourcesOfMoney: Array<PaymentDetailsSourceOfMoneyViewModel>;
    /**
     * 
     * @type {Array<PaymentDetailsCashTransferInvestmentViewModel>}
     * @memberof PaymentDetailsCashTransferViewModel
     */
    investments: Array<PaymentDetailsCashTransferInvestmentViewModel>;
    /**
     * 
     * @type {InvestmentDetailsSourceOfMoneySplitViewModel}
     * @memberof PaymentDetailsCashTransferViewModel
     */
    sourceOfMoneySplit?: InvestmentDetailsSourceOfMoneySplitViewModel;
}

/**
 * Check if a given object implements the PaymentDetailsCashTransferViewModel interface.
 */
export function instanceOfPaymentDetailsCashTransferViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paymentCategoryId" in value;
    isInstance = isInstance && "totalAmount" in value;
    isInstance = isInstance && "sourcesOfMoney" in value;
    isInstance = isInstance && "investments" in value;

    return isInstance;
}

export function PaymentDetailsCashTransferViewModelFromJSON(json: any): PaymentDetailsCashTransferViewModel {
    return PaymentDetailsCashTransferViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsCashTransferViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsCashTransferViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentCategoryId': json['PaymentCategoryId'],
        'paymentMethodId': !exists(json, 'PaymentMethodId') ? undefined : json['PaymentMethodId'],
        'totalAmount': json['TotalAmount'],
        'partyId': !exists(json, 'PartyId') ? undefined : json['PartyId'],
        'isInvestor': !exists(json, 'IsInvestor') ? undefined : json['IsInvestor'],
        'investmentNames': !exists(json, 'InvestmentNames') ? undefined : ((json['InvestmentNames'] as Array<any>).map(SimplifiedLookupResponseViewModelFromJSON)),
        'hasSingleInvestmentName': !exists(json, 'HasSingleInvestmentName') ? undefined : json['HasSingleInvestmentName'],
        'sourcesOfMoney': ((json['SourcesOfMoney'] as Array<any>).map(PaymentDetailsSourceOfMoneyViewModelFromJSON)),
        'investments': ((json['Investments'] as Array<any>).map(PaymentDetailsCashTransferInvestmentViewModelFromJSON)),
        'sourceOfMoneySplit': !exists(json, 'SourceOfMoneySplit') ? undefined : InvestmentDetailsSourceOfMoneySplitViewModelFromJSON(json['SourceOfMoneySplit']),
    };
}

export function PaymentDetailsCashTransferViewModelToJSON(value?: PaymentDetailsCashTransferViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PaymentCategoryId': value.paymentCategoryId,
        'PaymentMethodId': value.paymentMethodId,
        'TotalAmount': value.totalAmount,
        'PartyId': value.partyId,
        'IsInvestor': value.isInvestor,
        'InvestmentNames': value.investmentNames === undefined ? undefined : ((value.investmentNames as Array<any>).map(SimplifiedLookupResponseViewModelToJSON)),
        'HasSingleInvestmentName': value.hasSingleInvestmentName,
        'SourcesOfMoney': ((value.sourcesOfMoney as Array<any>).map(PaymentDetailsSourceOfMoneyViewModelToJSON)),
        'Investments': ((value.investments as Array<any>).map(PaymentDetailsCashTransferInvestmentViewModelToJSON)),
        'SourceOfMoneySplit': InvestmentDetailsSourceOfMoneySplitViewModelToJSON(value.sourceOfMoneySplit),
    };
}

